import { useCallback } from 'react';
import { getPageSizeForOrientation, type PageOrientation } from '../shared/gridConfig';
import { useRepositionBlocksOnCanvasResize } from './useRepositionBlocksOnCanvasResize';
import type { MovedBlock } from '../UndoRedo/UpdateDocumentSettingsCommand';

export function useOrientationChangeHandler(
  previousOrientation: PageOrientation | undefined,
  pageSizeLabel: string | undefined,
  persist: (orientation: PageOrientation, movedBlocks: MovedBlock[]) => void
) {
  const repositionBlocksOnCanvasResize = useRepositionBlocksOnCanvasResize();

  return useCallback(
    async (orientation: PageOrientation) => {
      const previousCanvasWidth = getPageSizeForOrientation(pageSizeLabel, previousOrientation).width;
      const newCanvasWidth = getPageSizeForOrientation(pageSizeLabel, orientation).width;
      const movedBlocks = await repositionBlocksOnCanvasResize(previousCanvasWidth, newCanvasWidth).catch(() => []);
      persist(orientation, movedBlocks);
    },
    [repositionBlocksOnCanvasResize, previousOrientation, pageSizeLabel, persist]
  );
}
